import { BmInvestmentFg, BudgetModelFormGroup } from "../../../pojo/bm-form";
import { BmTotalAccumulatedCapCalcService } from "../../total/accumulated/bm-total-accumulated-cap-calc.service";
import { BmInvestmentFormService } from "../../investment/bm-investment-form.service";
import { FormGroup } from "@angular/forms";
import { BmPeriodEnum } from "../../../pojo/bm-classes";
import { BmTotalGeneralCalcService } from "../../total/general/BmTotalGeneralCalcService";

export class BmSubscriptionsInvestmentHelperService {

  public static subscribeToInvestment(invFG: FormGroup<BmInvestmentFg>, budgetForm: BudgetModelFormGroup): void {
    invFG.controls.investmentValue.valueChanges.subscribe(() => {
      BmInvestmentFormService.recalculateInvestment(invFG);
      BmSubscriptionsInvestmentHelperService.recalculateRelatedValues(budgetForm);
    });
  }

  public static subscribeToItemsPcnt(invFG: FormGroup<BmInvestmentFg>, budgetForm: BudgetModelFormGroup): void {
    invFG.controls.itemsPcnt.valueChanges.subscribe(() => {
      invFG.controls.itemsPcnt.controls.forEach((item) => {
        if (item.value.period.type === BmPeriodEnum.YEAR) {
          BmInvestmentFormService.handleYearPcntChange(invFG);
          BmSubscriptionsInvestmentHelperService.recalculateRelatedValues(budgetForm);
        }
      });
    });
  }

  public static subscribeToItemsValue(invFG: FormGroup<BmInvestmentFg>, budgetForm: BudgetModelFormGroup): void {
    invFG.controls.itemsValue.valueChanges.subscribe(() => {
      invFG.controls.itemsValue.controls.forEach((item) => {
        if (item.value.period.type === BmPeriodEnum.YEAR) {
          BmInvestmentFormService.handleYearValueChange(invFG);
          BmSubscriptionsInvestmentHelperService.recalculateRelatedValues(budgetForm);
        }
      });
    });
  }


  /**
   * Recalculate all investment related values
   * - total Capital Required
   * - total accumulated required
   */
  public static recalculateRelatedValues(budgetForm: BudgetModelFormGroup): void {
    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalCapRequired, true);
    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalExpenses, false);
    BmTotalGeneralCalcService.recalculateAllRowValuePcnt(budgetForm);
    BmTotalAccumulatedCapCalcService.recalculateTotalAccumulatedRequired(budgetForm);
  }
}
